import { cloneDeep, isEqual, toArray } from "lodash";
import React, { Component, Fragment } from "react";
import { PACKAGE_RATE_PRODUCT_TYPE, PACKAGE_RATE_MARKUP_TYPE } from "../../../../../../constants/Define";
import Button from "../../../../common/component/Button";
import * as HMS from "../../../../common/component/Index";
import Select, { Option } from "../../../../common/component/Select";
import Wrapper from './../../../../common/component/Wrapper/index';
import { ListComponent } from './../../../../common/component/Index';
import * as Func from "../../../../../../helpers/functions";
import Input from "../../../../common/component/Input";
import Modal from "../../../../common/component/Modal";
import { Checkbox, Icon, InputNumber, message } from "antd";
import AntSelect, { AntOption } from "../../../../common/component/AntSelect";
import CheckboxGroup from "antd/lib/checkbox/Group";
import UpsellConfig from "./components/UpsellConfig";

const ListCols = ['packageRateProductType', 'codeService', 'nameService', 'calculationRule', 'postingRhythm', 'information', 'cost', 'markupType', 'markupValue', 'action'];
const ModelObjectFields = ['packageRateProductType', 'calculationRule', 'postingRhythm', 'imageLink', 'amenityId', 'code', 'name', 'cost', 'markupType', 'markupValue'];
export default class PackageRateProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ProductTypes: toArray(PACKAGE_RATE_PRODUCT_TYPE),
      MarkupTypes: toArray(PACKAGE_RATE_MARKUP_TYPE),
      hotelId: null,
      preHotelId: null,
      bookableId: null,
      isShowConfirmChangeHotel: false,
      errorBookble: null,
      roomType: {
        indeterminate: false,
        checkAll: false,
        plainOptions: [],
      },
      productTable: {
        titleTable: Func.getTitleTable(ListCols, [], ["id"]),
        modelTable: ModelObjectFields,
        componentTable: {
          packageRateProductType: {
            render: (value) => {
              const type = this.state.ProductTypes.find(
                (x) => x.value === value
              );
              return type?.label;
            },
          },
          codeService: {
            render: (value, record) => record["code"]
          },
          nameService: {
            render: (value, record) => record["name"]
          },
          information: {
            render: (value, record) => {
              return(
                <div className="wrap-info">
                  <div className="wrap-info-imgs">
                    <div className="wrap-info-imgs_img">
                      {record.imageLink && <img src={this.convertUrlImage(record.imageLink)} alt={record?.name}/>}
                    </div>
                    <div className="wrap-info-imgs_amenity">
                      {record.amenityId && <img src={this.convertUrlImage(record.amenityId)} alt={record?.name}/>}
                    </div>
                  </div>
                  <div className="wrap-info-text">
                    {record?.name}
                  </div>
                </div>
              )
            }
          },
          cost: {
            render: (value) =>
              !!value ? value : this.props.t("item.packageRate.costUndefine"),
          },
          markupType: {
            width: 100,
            render: (value, record, index) => (
              <HMS.FormWrapperInputComponent
                isRequired={"hide"}
                isValidation={true}
                dataValidation={value}
                messageBelowInput={true}
                validation={this.props.validation?.resultList?.length > index ? this.props.validation.resultList[index].markupType : null}
              >
                <AntSelect
                  style={{width: 100}}
                  name={`markupType-${index}`}
                  value={value}
                  onChange={(e) =>
                    this.onChangeMarkupType(e, index)
                  }
                  disabled={this.props.disabled}
                >
                  {this.state.MarkupTypes.map((item) => (
                    <Option key={item.value} value={item.value}>
                      {item.label}
                    </Option>
                  ))}
                </AntSelect>
              </HMS.FormWrapperInputComponent>
            ),
          },
          markupValue: {
            width: 100,
            render: (value, record, index) => (
              <HMS.FormWrapperInputComponent
                isRequired={"hide"}
                isValidation={true}
                dataValidation={value}
                messageBelowInput={true}
                validation={this.props.validation?.resultList?.length ? this.props.validation.resultList[index].markupValue : null}
              >
                <InputNumber
                  style={{width: 100}}
                  min={0} max={record.markupType === PACKAGE_RATE_MARKUP_TYPE.PERCENTAGE.value ? 100 : undefined}
                  name={`markupValue-${index}`}
                  size="large"
                  value={value}
                  onChange={(e) =>
                    this.onChangeMarkupValue(e, index)
                  }
                  disabled={this.props.disabled}
                />
              </HMS.FormWrapperInputComponent>
            ),
          },
          action: {
            render: (value, record, index) => (
              <div className="d-flex-inline">
                {
                  !this.props.disabled && (
                    <Button
                      className="mx-1 border-0"
                      onClick={() => this.onDeleteService(index)}
                    >
                      <Icon type="delete" />
                    </Button>
                  )
                }
              </div>
            ),
          },
        },
      },
    };
  }

  componentDidMount() {
    const { match } = this.props;
    match.params.id && this.props.getPackageRateProduct(match.params.id);
    this.props.getAllHotels();
  }

  componentWillReceiveProps(nextProps) {
    //default hotel when edit
    if (nextProps.PackageRateProduction && !isEqual(nextProps.PackageRateProduction, this.props.PackageRateProduction)) {
      const hotelId = nextProps.PackageRateProduction?.hotelId;
      this.setState({hotelId: hotelId});
      if(hotelId){
        this.props.getListRates({ hotelId });
        this.props.getListAllBookablePackageRates(hotelId);
        this.props.getAllRoomTypesByHotel(hotelId);
      }
    }

    // load roomtype
    if (nextProps.roomTypes && !isEqual(nextProps.roomTypes, this.props.roomTypes)) {
        const roomTypes = (nextProps.roomTypes || []).map(x=>({value: x.id, label: x.name}));
        const { PackageRateProduction } = this.props
        const indeterminateRoomType = PackageRateProduction?.roomTypeIds?.length > 0 && PackageRateProduction?.roomTypeIds?.length < roomTypes.length;
        const checkAllRoomType = PackageRateProduction?.roomTypeIds?.length === roomTypes.length;
        this.setState({roomType: {...this.state.roomType, plainOptions: roomTypes, indeterminate: indeterminateRoomType, checkAll: checkAllRoomType }});
    }
  }

  convertUrlImage(url) {
    return url?.includes('https://') ? url : `https://${url}`
  }

  onChangeHotel = (hotelId) => {
    this.setState({hotelId: hotelId});
    if (hotelId) {
      this.props.getListRates({ hotelId });
      this.props.getListAllBookablePackageRates(hotelId);
      this.props.getAllRoomTypesByHotel(hotelId);
    }
    this.props.onChange("hotelId", hotelId);

    //reset state
    this.setState({ ratePlanId: null, rateCodeId: null, bookableId: null });

    //reset model
    this.props.onChange("ratePlan", {});
    this.props.onChange("bookablePackageRates", []);
    this.props.onChange("ratePlanUpSell", []);
    this.props.onChange("roomTypeIds", []);

    this.setState({isShowConfirmChangeHotel: false});
  };

  onChangeRate = (ratePlanId) => {
    const { rates } = this.props;
    const item = rates.find((x) => x.id === ratePlanId);
    this.props.onChange("ratePlan.ratePlanId", item.id);
    this.props.onChange("ratePlan.refId", item.refId);
    this.props.onChange("ratePlan.code", item.code);
    this.props.onChange("ratePlan.name", item.name);
    this.props.onChange(
      "ratePlan.packageRateProductType",
      PACKAGE_RATE_PRODUCT_TYPE.RATEPLAN.value
    );
    this.props.onChange("ratePlan.cost", "");
    this.props.onChange("ratePlanUpSell", []);
  };

  onChangeBookable = () => {
    const { bookablePackageRates, PackageRateProduction } = this.props;
    const list = PackageRateProduction?.bookablePackageRates || [];

    // check exists
    if (list.findIndex((x) => x.bookableId === this.state.bookableId) > -1) {
      return;
    }

    const item = bookablePackageRates.find(
      (x) => x.bookableId === this.state.bookableId
    );

    this.props.onChange("bookablePackageRates", [
      ...list,
      {
        bookableId: item.bookableId,
        refId: item.refId,
        code: item.code,
        name: item.name,
        packageRateProductType: PACKAGE_RATE_PRODUCT_TYPE.BOOKABLE.value,
        imageLink: item.imageLink,
        calculationRule: item.calculationRule,
        postingRhythm: item.postingRhythm,
        amenityId: item.amenityId,
        // packageRateTicketResponse: {
        //   specifiedQuantity: 2,
        //   lenghOfStay: 3,
        //   numberOfRoom: 1,
        //   adultQuantity: 1,
        //   childQuantity: 2,
        //   seniorQuantity: 3,
        // },
      },
    ]);

    // clear
    this.setState({ bookableId: null })
  };

  onChangeMarkupType = (value, index) => {
    const bookable = [
      ...this.props.PackageRateProduction?.bookablePackageRates,
    ];
    bookable[index]["markupType"] = value;
    this.props.onChange("bookablePackageRates", bookable);
  };

  onChangeMarkupValue = (value, index) => {
    const bookable = [
      ...this.props.PackageRateProduction?.bookablePackageRates,
    ];
    bookable[index]["markupValue"] = value;
    this.props.onChange("bookablePackageRates", bookable);
  };

  onOpenChangeHotelModal = (newValue) => {
    if(!this.state.hotelId && newValue){
      this.onChangeHotel(newValue);
    }else{
      this.setState({preHotelId: newValue});
      this.setState({isShowConfirmChangeHotel: true});
    }
  }

  onDeleteService = (index) => {
    const bookables = cloneDeep(this.props.PackageRateProduction?.bookablePackageRates || []);

    let newList = [];
    if(bookables.length > 1){
      bookables.splice(index, 1);
      newList = bookables;
    }

    this.props.onChange("bookablePackageRates", newList);
  }

  onSelectBookable = (value, opt) => {
    this.setState({ bookableId: value });
    if(!opt.props?.data?.newName){
      this.setState({ errorBookble: { classError: "hms-error-form", messageError: "Bookable chưa được khai báo tên hiển thị trên VPT"} });
    }else{
      this.setState({ errorBookble: null });
    }
  }

  getBookables = () => {
    const {bookablePackageRates, PackageRateProduction} = this.props;

    const bookableNotSelected = (bookablePackageRates || []).filter(x => {
      return (PackageRateProduction?.bookablePackageRates || []).findIndex( y => y.bookableId === x.bookableId) < 0;
    });

    return bookableNotSelected;
  }

  onChangeRoomType = (list) => {
    const { plainOptions } = this.state.roomType;
    const indeterminateRoomType = !!list.length && list.length < plainOptions.length;
    const checkAllRoomType = list.length === plainOptions.length;
    this.setState({roomType: {...this.state.roomType, indeterminate: indeterminateRoomType, checkAll: checkAllRoomType }});
    this.props.onChange("roomTypeIds", list);
  };

  onCheckAllChangeRoomType = (e) => {
    const { plainOptions } = this.state.roomType;
    const checkedRoomTypeList = e.target.checked ? plainOptions.map(x=>x.value) : [];
    this.setState({roomType: {...this.state.roomType, indeterminate: false, checkAll: e.target.checked }});
    this.props.onChange("roomTypeIds", checkedRoomTypeList);
  };

  render() {
    const {
      t,
      validation,
      PackageRateProduction,
      hotels,
      rateCodes,
      bookablePackageRates,
      rates,
      disabled
    } = this.props;
    const { productTable, roomType } = this.state;
    const { modelTable, titleTable, componentTable } = productTable;
    const { plainOptions } = roomType;

    return (
      <div className="basic-info">
        <div className="basic-info-box">
          <div className="package-rate-prod-tab">
            <div className="pr-row">
              <div>
                <h3 className="mb-0">{t("item.packageRate.selectRatePlan")}</h3>

                <div className="pr-row flex-fill">
                  <div className="pr-label">
                    {t("item.packageRate.selectHotel")}{" "}
                    <span className="colorRed mr-1 title-required">*</span>
                  </div>
                  <div className="d-flex flex-fill">
                    <HMS.FormWrapperInputComponent
                      isRequired={"hide"}
                      isValidation={true}
                      dataValidation={PackageRateProduction.hotelId}
                      validation={validation.hotelId}
                      typeInput={true}
                      className={"px-3 m-0 w-100"}
                      classLabel={"d-none"}
                      classInputForm={"w-100"}
                    >
                      <AntSelect
                        name={`pk-hotel`}
                        placeholder={t("item.packageRate.selectHotelPlaceholder")}
                        showArrow
                        showSearch
                        optionFilterProp="children"
                        value={this.state.hotelId}
                        onChange={(e) => this.onOpenChangeHotelModal(e)}
                        disabled={disabled}
                      >
                        {hotels.map((item) => (
                          <AntOption key={item.id} value={item.id}>
                            {item.code} - {item.name}
                          </AntOption>
                        ))}
                      </AntSelect>
                    </HMS.FormWrapperInputComponent>
                  </div>
                </div>

                <div className="pr-row flex-fill">
                  <div className="pr-label">
                    {t("item.packageRate.selectRate")}{" "}
                    <span className="colorRed mr-1 title-required">*</span>
                  </div>
                  <div className="d-flex flex-fill">
                    <HMS.FormWrapperInputComponent
                      isRequired={"hide"}
                      isValidation={true}
                      dataValidation={PackageRateProduction.ratePlan}
                      validation={validation?.ratePlan?.ratePlanId}
                      typeInput={true}
                      className={"px-3 m-0 w-100"}
                      classLabel={"d-none"}
                      classInputForm={"w-100"}
                    >
                      <AntSelect
                        name={`pk-rate`}
                        placeholder={t("item.packageRate.selectRatePlaceholder")}
                        showArrow
                        showSearch
                        optionFilterProp="children"
                        value={PackageRateProduction?.ratePlan?.ratePlanId}
                        onChange={(e) =>
                          this.onChangeRate(e)
                        }
                        disabled={disabled || PackageRateProduction.hotelId == null}
                      >
                        {rates.map((item) => (
                          <AntOption key={item.id} value={item.id}>
                            {item.code} - {item.name}
                          </AntOption>
                        ))}
                      </AntSelect>
                    </HMS.FormWrapperInputComponent>
                  </div>
                </div>

                <div className="pr-row flex-fill align-items-start">
                  <div className="pr-label">
                    {t("item.packageRate.selectRoomType")}{" "}
                    <span className="colorRed mr-1 title-required">*</span>
                  </div>
                  <div className="d-flex flex-fill">
                    <HMS.FormWrapperInputComponent
                      isRequired={"hide"}
                      isValidation={true}
                      dataValidation={PackageRateProduction.roomTypeIds}
                      validation={validation?.roomTypeIds}
                      typeInput={true}
                      className={"px-3 m-0 w-100"}
                      classLabel={"d-none"}
                      classInputForm={"w-100"}
                    >
                      {
                        plainOptions?.length > 0 && (
                          <>
                            <Checkbox indeterminate={this.state.roomType.indeterminate} onChange={this.onCheckAllChangeRoomType} checked={this.state.roomType.checkAll}>
                              Check all
                            </Checkbox>
                            <CheckboxGroup className="d-flex flex-column" options={plainOptions} value={PackageRateProduction.roomTypeIds} onChange={this.onChangeRoomType} />
                          </>
                        )
                      }
                    </HMS.FormWrapperInputComponent>
                  </div>
                </div>
              </div>
            </div>

            <h3 className="mb-0 mt-5">{t("item.packageRate.selectPMSSevices")}</h3>
            <div className="pr-row">
              <div>
                <div className="pr-row flex-fill">
                  <div className="pr-label">{t("item.packageRate.selectBookables")}</div>
                  <div className="d-flex flex-fill">
                    <HMS.FormWrapperInputComponent
                      isRequired={"hide"}
                      isValidation={true}
                      dataValidation={PackageRateProduction.hotelId}
                      validation={this.state.errorBookble}
                      typeInput={true}
                      className={"px-3 m-0 w-100 bookable-container"}
                      classLabel={"d-none"}
                      classInputForm={"w-100"}
                    >
                      <AntSelect
                        name={`pk-bookable`}
                        placeholder={t("item.packageRate.selectBookablePlaceholder")}
                        showArrow
                        showSearch
                        optionFilterProp="children"
                        value={this.state.bookableId}
                        onChange={(e, opt) => this.onSelectBookable(e, opt)}
                        disabled={disabled || PackageRateProduction.hotelId == null}
                      >
                        {this.getBookables().map((item) => (
                            item.isActive &&
                            (<AntOption key={item.bookableId} value={item.bookableId} data={item}>
                              {`${item.code}${item.newName ? " - " + item.newName : ""}`}
                            </AntOption>)
                        ))}
                      </AntSelect>
                    </HMS.FormWrapperInputComponent>
                  </div>
                </div>
              </div>

              <Button
                className="ml-4"
                disabled={!this.state.bookableId || this.state.errorBookble}
                onClick={this.onChangeBookable}
              >
                {t("item.packageRate.add")}
              </Button>
            </div>

            {PackageRateProduction.bookablePackageRates.length > 0 && (
              <Wrapper className="w-100">
                <ListComponent
                  tableKey="table-package-rate-products"
                  rowKey={(record, index) => index}
                  dataSource={Func.getDataSource(PackageRateProduction.bookablePackageRates, modelTable)}
                  columns={Func.columnsTable({
                    titleTable: titleTable,
                    component: componentTable,
                    itemName: "packageRate",
                  })}
                />
              </Wrapper>
            )}

            <UpsellConfig t={t} disabled={disabled} PackageRateProduction={PackageRateProduction} ratePlans={rates} onChange={this.props.onChange} />
          </div>
        </div>

        <Modal
            title={t('item.packageRate.confirmChangeHotel')}
            visible={this.state.isShowConfirmChangeHotel}
            width={400}
            onOk={() => this.onChangeHotel(this.state.preHotelId)}
            onCancel={() => this.setState({isShowConfirmChangeHotel: false})}
            okText={t('action.confirm')}
            closable={false}
        >
            <Fragment>
                <div>{t("item.packageRate.confirmChangeHotelContent1")}</div>
                <div><Icon type="warning"/> {t("item.packageRate.confirmChangeHotelContent2")}</div>
            </Fragment>
        </Modal>
      </div>
    );
  }
}
